import React from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { Box, HStack, Input, Stack } from '@chakra-ui/react';
import { toArray } from 'lodash';
import map from 'lodash/map';

import { Select, textFieldStyles } from 'components/DataEntry';
import {
  renderDataAccessFormLabel,
  renderDeleteAttribute,
} from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/utils';

interface Props {
  state: Record<string, any>;
  updateState: (state: any) => void;
  onDeleteAttribute: (item: Record<string, any>, field: string) => void;
}

export const AddBuckets = (props: Props) => {
  const { state, updateState, onDeleteAttribute } = props;

  return (
    <Stack spacing={4}>
      <HStack>
        {renderDataAccessFormLabel('Buckets', '45%')}
        {renderDataAccessFormLabel('Region', '15%')}
        {renderDataAccessFormLabel('Object Location', '35%')}
      </HStack>
      {map(state?.buckets, o => (
        <HStack>
          <Box w="45%">
            <Select
              value={o?.value}
              showClearIndicator={false}
              options={
                state?.resourceOptions?.[NativeResources.SimpleStorageService]
              }
              onChange={val => {
                updateState(prev => ({
                  ...prev,
                  buckets: {
                    ...prev.buckets,
                    [o.id]: {
                      ...o,
                      value: val,
                      path: '',
                      region:
                        val?.value === 'all'
                          ? state?.regionOptions?.[0]
                          : {
                              label: val?.data?.region,
                              value: val?.data?.region,
                            },
                    },
                  },
                  isInvalid: false,
                }));
              }}
            />
          </Box>
          <Box w="15%">
            <Select
              value={o?.region}
              showClearIndicator={false}
              options={state?.regionOptions}
              isDisabled={o?.value?.value !== 'all'}
            />
          </Box>
          <Box w="35%">
            <Input
              {...textFieldStyles.input}
              value={o?.path}
              onChange={e => {}}
            />
          </Box>
          {renderDeleteAttribute(
            () => onDeleteAttribute(o, 'buckets'),
            toArray(state?.buckets)?.length === 1,
          )}
        </HStack>
      ))}
    </Stack>
  );
};
